// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { AppClientDetails } from '@takectrl-multiapp/svcs-share-config';

export const environment = {
  production: false,
  app_client_detail: AppClientDetails.CTRL,
  firebase: {
    apiKey: 'AIzaSyDy9QHx_X7qpgG9lj-xLyxBGhXzsqgoBDA',
    authDomain: 'takectrl-709cd.firebaseapp.com',
    databaseURL: 'https://takectrl-709cd.firebaseio.com',
    projectId: 'takectrl-709cd',
    storageBucket: 'takectrl-709cd.appspot.com',
    messagingSenderId: '60080011007',
    appId: '1:60080011007:web:06b3646e68fd7002717eca',
    measurementId: 'G-X6SMB70Z7H',
  },
  application: {
    login_heading: 'STAGING',
    login_heading_color: '#ff0000',
  },
  ctrl_api_url: 'https://msti-ctrl-api-pre.msti-ctrl-nonprod.awspriv.mmih.biz/api',
  intercom_app_id: 'oqa6vt8b',
  firebase_functions_url: 'https://us-central1-takectrl-709cd.cloudfunctions.net',
    
  decryptionKey: 'BAKDO2APWP8KK00!',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.

